module.exports = __webpack_public_path__ + "static/media/logo-concrete.880c2e94.png";